import {
  AppDownloadScanner,
  BackgroundEffectPDFError,
  redAlertImage,
} from 'assets';
import AppStoreGetIcon from 'assets/Icons/AppStoreGetIcon';
import PlayStoreGetIcon from 'assets/Icons/PlayStoreGetIcon';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

import { montserrat } from '@/components/Layout';
import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

interface FailedToLoadPDFProps {
  title?: string;
  description?: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  contactText?: string;
  contactLink?: string;
  imageSrc: string;
}

const FailedToLoadPDF: React.FC<FailedToLoadPDFProps> = ({
  title = 'Our systems are temporarily down due to high traffic.',
  description = 'Please wait 10–20 minutes and try again.',
  primaryButtonText = 'Explore Schools',

  secondaryButtonText = 'Go Back',
  // contactText = 'Contact us',
  // contactLink = '/contact',
  // secondaryButtonLink = '/',
  // imageSrc,
  primaryButtonLink,
}) => {
  const router = useRouter();

  return (
    // <div className='flex flex-col-reverse pb-10 lg:flex-row no-scrollbar overflow-hidden items-center justify-between max-h-[80%] h-full text-white w-full'>
    //   <div className='flex flex-col items-center lg:items-start text-center lg:text-left space-y-4 lg:w-2/5 px-20'>
    //     <h1 className='text-xl lg:text-4xl font-bold mt-6'>{title}</h1>
    //     <p
    //       style={{
    //         color: 'var(--Grey-500-F, #C7C6CF)',
    //       }}
    //       className='lg:text-lg'
    //     >
    //       {description}
    //     </p>
    //     <div className='flex space-x-4 pt-2'>
    //       <Button
    //         type='default'
    //         className='px-6 py-4 bg-white text-black border-white font-semibold rounded-full'
    //         onClick={() => {
    //           router.push(secondaryButtonLink);
    //         }}
    //       >
    //         {secondaryButtonText ?? 'Default Text'}
    //       </Button>
    //       <Button
    //         type='text'
    //         onClick={() => {
    //           if (typeof window !== undefined) {
    //             window.location.reload();
    //           }
    //         }}
    //         className='px-6 py-4 border-white font-semibold rounded-full'
    //       >
    //         {primaryButtonText}
    //       </Button>
    //     </div>
    //     <p className='text-xs lg:text-sm text-textGray  lg:w-full pt-5 lg:pt-3'>
    //       If you still have the issue,{' '}
    //       <Link
    //         href={contactLink}
    //         className='text-white underline text-xs md:text-sm tracking-wide'
    //       >
    //         {contactText}
    //       </Link>
    //     </p>
    //   </div>

    //   <div className='lg:ml-8 lg:w-3/5 flex items-end mt-10 lg:mt-20 justify-end'>
    //     <div className='h-[220px] lg:h-full'>
    //       <Image
    //         src={imageSrc}
    //         width={740}
    //         height={446}
    //         alt='System Down Illustration'
    //         className='w-full h-full'
    //         priority
    //       />
    //     </div>
    //   </div>
    // </div>
    <div
      style={{
        fontFamily: montserrat.style.fontFamily,
      }}
      className='bg-stroke lg:pt-[33px] lg:pl-[90px] lg:pb-[44px] lg:pr-[141px] pt-[33px] pl-[16px] sm:pb-[44px] pb-5 pr-[16px] lg:mt-[140px] sm:mt-0 mt-11 relative overflow-hidden'
    >
      <div className='relative flex items-center gap-10 z-20 lg:flex-row flex-col justify-between'>
        <div>
          <div className='flex items-center lg:gap-2 md:gap-5 gap-1.5 lg:mb-[15px] sm:mb-5 mb-3 lg:flex-row flex-col'>
            <Image
              alt={title}
              src={redAlertImage}
              width={43}
              height={43}
              className='w-[43px] h-[43px]'
            />
            <p className='text-white sm:text-[40px]/[48px] text-2xl font-bold lg:text-left text-center'>
              {title}
            </p>
          </div>
          <p className='text-white sm:text-xl text-sm/[20px] sm:mb-9 mb-[50px] lg:text-left text-center text-balance'>
            {description}
          </p>
          <div className='flex items-center sm:gap-2 gap-5 sm:mb-5 mb-[66px] flex-wrap lg:justify-start justify-center lg:flex-row flex-col'>
            <Link href={primaryButtonLink || ''} className='sm:w-auto w-full'>
              <ButtonDefault
                className='py-2.5 px-9 rounded-lg sm:text-base text-sm font-semibold text-white text-nowrap lg:w-auto sm:w-[358px] w-full '
                size={0}
                variant={ButtonVariants.PRIMARY}
              >
                {primaryButtonText}
              </ButtonDefault>
            </Link>
            <ButtonDefault
              onClick={() => router.reload()}
              className='text-nowrap py-2.5 px-6 rounded-lg sm:text-base text-sm font-semibold  border border-white text-white lg:w-auto sm:w-[358px] w-full'
              size={0}
              variant={ButtonVariants.UNSTYLED}
            >
              {secondaryButtonText}
            </ButtonDefault>
          </div>
          <p className='sm:text-sm text-xs text-white text-[22px] lg:text-start text-center'>
            If you still having the issue,{' '}
            <Link
              className='font-semibold underline hover:text-white/90'
              href="/contact"
            >
              Contact Support
            </Link>
          </p>
        </div>
        <div className='sm:flex hidden flex-col items-center gap-3 '>
          <Image
            alt='AppDownloadScanner'
            src={AppDownloadScanner}
            width={378}
            height={335}
            className='min-w-[378px] min-h-[335px]'
          />
          <div className='flex items-center gap-2'>
            <PlayStoreGetIcon
              className='w-[160px]'
              onClick={() => {
                if (typeof window !== undefined) {
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.zebralearn.reader&referrer=utm_source%3Dzebralearn%26utm_medium%3Dwebsite%26utm_campaign%3Ddownload_app&pli=1' as string,
                    '_blank',
                  );
                }
              }}
            />
            <AppStoreGetIcon
              className='w-[160px]'
              onClick={() => {
                if (typeof window !== undefined) {
                  window.open(
                    'https://apps.apple.com/in/app/zebralearn/id6477746268?utm_source=zebralearn_website',
                    '_blank',
                  );
                }
              }}
            />
          </div>
        </div>
      </div>
      <Image
        alt='BackgroundEffectPDFError'
        src={BackgroundEffectPDFError}
        width={1620}
        height={671}
        className='lg:w-[1620px] sm:w-[1411px] w-auto lg:h-[671px] sm:h-[802px] h-full absolute lg:top-[-95px] sm:top-[26px] top-0 lg:right-[-635px] sm:right-[-500px] right-[-50%] z-0'
      />
    </div>
  );
};

export default FailedToLoadPDF;
